import { statusColors } from '../../constants'

const AvatarStatus = ({
  status = 'offline',
  borderColor = 'border-[#FFF5EE]',
  position = 'bottom-[8px] right-[8px]',
  className = '',
}) => {
  return (
    <div
      style={{ backgroundColor: statusColors[status] || statusColors.offline }}
      className={`absolute ${position} z-[1] w-[20px] h-[20px] border-[4px] ${borderColor} rounded-full transition-colors duration-200 ease ${className}`}
    />
  )
}

export default AvatarStatus
